import React from 'react';
import {NoContent} from 'components/no-content';

class MyBusinessStatsContent extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <NoContent height={683}/>
    );
  }
}

export default MyBusinessStatsContent;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/stats-content/MyBusinessStatsContent.jsx